// Generated by ReScript, PLEASE EDIT WITH CARE


var banner_card_clicked = "banner_card_clicked";

var customer_service_card_clicked = "customer_service_card_clicked";

var login_activity_card_clicked = "login_activity_card_clicked";

var completed_orders_card_clicked = "completed_orders_card_clicked";

var rewards_and_gift_history_clicked = "rewards_and_gift_history_clicked";

var daily_rewards_clicked = "daily_rewards_clicked";

var level_gifts_clicked = "Level_gifts_clicked";

var reward_program_page_loaded = "reward_program_page_loaded";

var daily_rewards_card_clicked = "daily_rewards_card_clicked";

var level_gifts_card_clicked = "level_gifts_card_clicked";

var video_thumbnail_clicked = "video_thumbnail_clicked";

var video_page_loaded = "video_page_loaded";

var learn_more_clicked = "learn_more_clicked";

var claim_disabled_button_clicked = "claim_disabled_button_clicked";

var claim_cta_loaded = "claim_cta_loaded";

var claim_button_clicked = "claim_button_clicked";

var reward_program_congrats_page_loaded = "reward_program_congrats_page_loaded";

var reward_program_congrats_page_okay_clicked = "reward_program_congrats_page_okay_clicked";

export {
  banner_card_clicked ,
  customer_service_card_clicked ,
  login_activity_card_clicked ,
  completed_orders_card_clicked ,
  rewards_and_gift_history_clicked ,
  daily_rewards_clicked ,
  level_gifts_clicked ,
  reward_program_page_loaded ,
  daily_rewards_card_clicked ,
  level_gifts_card_clicked ,
  video_thumbnail_clicked ,
  video_page_loaded ,
  learn_more_clicked ,
  claim_disabled_button_clicked ,
  claim_cta_loaded ,
  claim_button_clicked ,
  reward_program_congrats_page_loaded ,
  reward_program_congrats_page_okay_clicked ,
  
}
/* No side effect */
